<template>
<div class="conteudo-sistema">
	<div class="fl-cabecalho">

		<div class="row animated slideInDown">
			<div class="col-12 form-group">
				<h4 class="animated slideInDown"><fa-icon icon="key" />
					Usuários
				</h4>
			</div>
		</div>

		<div class="row animated slideInDown">
			<div class="col-lg-4 col-12 col-xs-12 form-group">
				<flFind @key-up="(inputText) => $refs.table.filtraLista(inputText)"
						placeholder="Buscar"/>
			</div>
			<div class="col-12 col-xs-12 col-md-12 col-lg-2 form-group">
				<button @click="clickModal(null)" class="btn btn-sm btn-block btn-outline-dark">
					<fa-icon icon="plus"/> Novo
				</button>
			</div>
		</div>
	</div>

	<flCarregando style="margin-top:20px" v-if="load" />

	<fl-table v-show="!load"
				ref="table"
				:perPage="10"
				@click-editar="clickModal"
				columnStartSortable="nome"
				class="animated fadeIn fast"
				:columns="geraCabecalhos()" />

    <flModal @modal-hide="showForm = false" ref="modalCadastro" width="50%">
		<template v-slot:header>
			<span v-if="editar"><fa-icon icon="pen-alt"/> Editar</span>
			<span v-if="!editar"><fa-icon icon="plus"/> Novo</span>
		</template>
        <flCadastro v-if="showForm" ref="cadastro" :perfil="false" :perfis="perfis" @item-salvo="atualizaItem" />
    </flModal>
</div>
</template>

<script>
import flCadastro from "./cadastro.vue";
import flTable from '../../../components/table/main.vue'
import flModal from '../../../components/modal/main.vue'
import flCarregando from '../../../components/carregando/main.vue'
import axios from '../../../routers/axios'
import flFind from '../../../components/find/main.vue'

export default {
	components: {
		flCadastro,
		flTable,
		flModal,
		flCarregando,
		flFind
	},

	data() {
		return {

			showForm: false,
			editar: false,

			perfis: [],
			load: true
		};
	},

	mounted() {
		this.carregaDados()
	},

	methods: {

        clickModal(item){

			this.editar = item ? true : false
			this.showForm = true
			this.$refs.modalCadastro.show()
			this.$nextTick(() => {
                if(this.editar) this.$refs.cadastro.editar(item._object)
			})
        },

		atualizaItem(item) {

			this.$notify.show('success', 'Usuário salvo.')
			item = this.geraColunas(item)
			this.$refs.table.atualizaItem(item, 'id', item._object.id)
			this.exibeCadastro = false
			this.$refs.modalCadastro.hide()
		},

		carregaDados() {

			this.load = true
			axios.get(this._getUrl("api/login")).then(response => {
				this.load = false

				let list = response.data.map(item => { return this.geraColunas(item) })

				this.$refs.table.loadTable(list)
			});

			axios.get(this._getUrl("api/perfillogin")).then(response => {
				this.perfis = response.data
			});
		},

		geraColunas(item){

			let itemLista = {}
			let columns = []

			// nome
			columns.push({
				html : `${item.nome} <br/>
						<small class="${item.ativo ? 'text-success' : 'text-danger'}">
							${item.ativo ? 'ATIVO' : 'DESATIVADO'}
						</small>`,
			})

			// login
			columns.push({value: item.login })

			// celular
			columns.push({value: item.celular })

			// se tiver o provilegio o botão de editar
			if(this._getPrivilegio(20)){
				columns.push({
					class: 'text-center',
					clickable: true,
					event: 'click-editar',
					icon: ["fa", "pen-alt"],
					styleIcon: 'font-size: 0.9rem',
				})
			}

			itemLista._object = item
			itemLista.columns = columns
			return itemLista
		},

		geraCabecalhos(){

			let columns = []

			columns.push({
				name: 'Nome',
				key: 'nome',
				searchable: true,
				sortable: true,
				class: '',
				width: '30%',
			})

			columns.push({
				name: 'E-mail',
				key: 'login',
				searchable: true,
				sortable: true,
				class: '',
				width: '',
			})

			columns.push({
				name: 'Celular',
				key: 'celular',
				searchable: false,
				sortable: false,
				class: '',
				width: '',
			})

			if(this._getPrivilegio(20)){
				columns.push({
					name: 'Editar',
					key: 'editar',
					searchable: false,
					sortable: false,
					class: 'text-center',
					width: '8%',
				})
			}

			return columns
		},
	}
};
</script>



// WEBPACK FOOTER //
// src/views/adm/usuario/main.vue